import React from 'react'

const CoursesLoading = () => {
  return (
    <>
    <div className='lg:w-96 md:w-56 sm:w-42 bg-white rounded-lg overflow-hidden m-4 h-96 w-96 opacity-30 animate-pulse'>
        <div className='w-90 h-40 bg-slate-300 m-1 rounded-lg'></div>
        <div className='w-80 h-8 bg-slate-300 m-1 mt-2 ml-3 rounded-lg'></div>
        <div className='flex justify-center mt-4'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>            
        <div className='flex justify-center mt-2'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
        <div className='flex justify-center mt-3'>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
    </div>    
    <div className='lg:w-96 md:w-56 sm:w-42 bg-white rounded-lg overflow-hidden m-4 h-96 w-96 opacity-30 animate-pulse'>
        <div className='w-90 h-40 bg-slate-300 m-1 rounded-lg'></div>
        <div className='w-80 h-8 bg-slate-300 m-1 mt-2 ml-3 rounded-lg'></div>
        <div className='flex justify-center mt-4'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>            
        <div className='flex justify-center mt-2'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
        <div className='flex justify-center mt-3'>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
    </div>
    <div className='lg:w-96 md:w-56 sm:w-42 bg-white rounded-lg overflow-hidden m-4 h-96 w-96 opacity-30 animate-pulse'>
        <div className='w-90 h-40 bg-slate-300 m-1 rounded-lg'></div>
        <div className='w-80 h-8 bg-slate-300 m-1 mt-2 ml-3 rounded-lg'></div>
        <div className='flex justify-center mt-4'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>            
        <div className='flex justify-center mt-2'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
        <div className='flex justify-center mt-3'>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
    </div>
    <div className='lg:w-96 md:w-56 sm:w-42 bg-white rounded-lg overflow-hidden m-4 h-96 w-96 opacity-30 animate-pulse'>
        <div className='w-90 h-40 bg-slate-300 m-1 rounded-lg'></div>
        <div className='w-80 h-8 bg-slate-300 m-1 mt-2 ml-3 rounded-lg'></div>
        <div className='flex justify-center mt-4'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>            
        <div className='flex justify-center mt-2'>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-8 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
        <div className='flex justify-center mt-3'>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
            <div className='w-40 h-4 bg-slate-300 m-1 my-2 rounded-lg'></div>
        </div>
    </div>
    

</>
  )
}

export default CoursesLoading